export enum AssessmentCustomStatusType {
  VIEW_STATUS = 'VIEW_STATUS',
  ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD_STATUS = 'ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD_STATUS',
}
